/* Soccer Band-Its personalizer — shared enhancements. */
(function(){
  /* 1) Prefix the font dropdown options with 'Font Type:' so it's clear what the control is. Runs on all devices. */
  function labelFonts(){
    try{
      var opts = document.querySelectorAll('select.sba__font option, select#sbaFont option');
      for(var i=0;i<opts.length;i++){
        var o = opts[i];
        var t = (o.textContent || '').trim();
        if(t && t.indexOf('Font Type:') !== 0){ o.textContent = 'Font Type: ' + t; }
      }
    }catch(e){}
  }

  /* 2) Capitalize the 'How to Personalize' accordion heading across all products. */
  function fixHeadings(){
    try{
      var sums = document.querySelectorAll('.sba__acc summary');
      for(var i=0;i<sums.length;i++){
        var nodes = sums[i].childNodes;
        for(var j=0;j<nodes.length;j++){
          var n = nodes[j];
          if(n.nodeType === 3 && n.textContent.indexOf('How to personalize') !== -1){
            n.textContent = n.textContent.replace('How to personalize', 'How to Personalize');
          }
        }
      }
    }catch(e){}
  }

  /* 2b) Make each text-colour picker an obvious labeled swatch: wrap it in .sba__colorctl and add a 'Text color' caption. Idempotent — skips any input already wrapped (e.g. the arm sleeve, which ships with it). CSS turns the wrapped swatch into a circle. */
  function labelColorPickers(){
    try{
      var inputs = document.querySelectorAll('.sba__right input[type="color"]');
      for(var i=0;i<inputs.length;i++){
        var inp = inputs[i];
        if(inp.closest && inp.closest('.sba__colorctl')){ continue; }
        var ctl = document.createElement('span');
        ctl.className = 'sba__colorctl';
        inp.parentNode.insertBefore(ctl, inp);
        ctl.appendChild(inp);
        var lbl = document.createElement('span');
        lbl.className = 'sba__colorlbl';
        lbl.textContent = 'Text color';
        ctl.appendChild(lbl);
      }
    }catch(e){}
  }

  /* 2d) Remove the 'Tip: tap any logo or text … then the × to remove it' hint — it's obvious and just adds clutter. Matched on the 'Tip:' prefix so the keychain's different note (about free mockups) is left in place. */
  function hideRemoveTip(){
    try{
      var hints = document.querySelectorAll('.sba__hint2');
      for(var i=0;i<hints.length;i++){
        var txt = (hints[i].textContent || '').trim();
        if(txt.indexOf('Tip:') === 0){ hints[i].style.display = 'none'; }
      }
    }catch(e){}
  }

  /* 2c) Volume-pricing bar (Option A, one connected graphic): prepend a green 'Buy more, save more · discounts apply automatically, no code needed' header, then colour each segment a deeper green as the discount grows, add a savings % under the price, and flag the top tier 'wholesale'. Idempotent per .sba__tiers. Works for any tier count. Products in NO_WHOLESALE (matched on _Style) show the bar without the 'wholesale' tag. */
  function styleTierBars(){
    try{
      var G = ['#E1F5EE','#9FE1CB','#5DCAA5','#1D9E75','#0F6E56','#085041','#04342C'];
      var NO_WHOLESALE = ['backpack','koozie'];
      var style = ((((document.getElementById('sbaStyle')||{}).value)||'').toLowerCase());
      var hideWholesale = NO_WHOLESALE.some(function(k){ return style.indexOf(k) !== -1; });
      function priceOf(cell){ var p = cell.querySelector('.p'); if(!p){ return null; } var m = (p.textContent||'').replace(/[^0-9.]/g,''); return m ? parseFloat(m) : null; }
      var wraps = document.querySelectorAll('.sba__vol .sba__tiers');
      for(var w=0; w<wraps.length; w++){
        var tiers = wraps[w];
        if(tiers.__sbaBar){ continue; } tiers.__sbaBar = true;
        var cells = tiers.querySelectorAll('.sba__tier');
        if(!cells.length){ continue; }
        var vol = tiers.parentNode;
        if(vol && vol.querySelector && !vol.querySelector('.sba__volhdr')){
          var hdr = document.createElement('div');
          hdr.className = 'sba__volhdr';
          hdr.innerHTML = '<i class="fa-solid fa-tags" aria-hidden="true"></i> <span class="sba__volh1">Buy more, save more</span> <span class="sba__volh2">· discounts apply automatically, no code needed</span>';
          vol.insertBefore(hdr, tiers);
        }
        var base = priceOf(cells[0]);
        var n = cells.length;
        for(var i=0; i<n; i++){
          var cell = cells[i];
          var qEl = cell.querySelector('.q');
          var pEl = cell.querySelector('.p');
          if(i > 0){
            var gi = Math.min(G.length-1, i);
            cell.style.background = G[gi];
            var darkText = gi >= 3;
            var tcol = darkText ? '#ffffff' : '#04342C';
            var scol = darkText ? '#9FE1CB' : '#0F6E56';
            if(qEl){ qEl.style.color = tcol; }
            if(pEl){ pEl.style.color = tcol; }
            var pr = priceOf(cell);
            if(base && pr != null && pr < base && !cell.querySelector('.s')){
              var pct = Math.round((base - pr) / base * 100);
              if(pct > 0){
                var s = document.createElement('div'); s.className = 's'; s.textContent = 'save ' + pct + '%'; s.style.color = scol; cell.appendChild(s);
              }
            }
          }
        }
        var last = cells[n-1];
        if(!hideWholesale && last && !last.querySelector('.best')){
          var b = document.createElement('div'); b.className = 'best'; b.textContent = 'wholesale'; b.style.color = '#9FE1CB'; last.insertBefore(b, last.firstChild);
        }
      }
    }catch(e){}
  }

  function runShared(){ labelFonts(); fixHeadings(); labelColorPickers(); hideRemoveTip(); styleTierBars(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', runShared); } else { runShared(); }
  var fn = 0; var fiv = setInterval(function(){ labelFonts(); if(++fn > 25){ clearInterval(fiv); } }, 200);

  /* 3) Keep the saved order tidy for the production team: drop the noisy technical line-item properties (raw design-data JSON, redundant style/colour) before the design is added to cart. Runs in the capture phase so it strips the field names before each section's own submit handler builds the form data. Keeps: logo file, Design preview, the text/font/colour, and the plain-English summary. */
  document.addEventListener('submit', function(e){
    try{
      var f = e.target;
      if(f && f.id === 'sbaForm'){
        ['sbaDesignData','sbaBandColor','sbaStyle'].forEach(function(id){
          var el = document.getElementById(id);
          if(el){ el.removeAttribute('name'); }
        });
      }
    }catch(err){}
  }, true);

  /* 4) Touch-friendly Fabric.js controls — only on touch devices, so the desktop look is unchanged. */
  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if(!isTouch) return;
  var tries = 0;
  function applyTouch(){
    if(typeof window.fabric === 'undefined'){ if(tries++ < 50){ setTimeout(applyTouch, 150); } return; }
    try{
      var P = window.fabric.Object.prototype;
      P.cornerSize = 24;
      if('touchCornerSize' in P){ P.touchCornerSize = 44; }
      P.cornerStyle = 'circle';
      P.transparentCorners = false;
      P.cornerColor = '#1c8a4a';
      P.cornerStrokeColor = '#ffffff';
      P.borderColor = '#1c8a4a';
    }catch(e){ return; }
    try{
      document.querySelectorAll('canvas.lower-canvas, #sbaCanvas').forEach(function(cv){
        var f = cv.__fabric; if(f && f.requestRenderAll){ f.requestRenderAll(); }
      });
    }catch(e){}
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', applyTouch); } else { applyTouch(); }
})();

/* 5) Text stays above logos. Logo images decode asynchronously, so a logo uploaded moments before text is typed can end up on top. Whenever a logo is added to a personalizer canvas, re-assert all text objects to the front. Separate IIFE so it runs on all devices (not blocked by the touch-only early return above). */
(function(){
  var t = 0;
  function hook(){
    var cv = document.getElementById('sbaCanvas');
    var f = cv && cv.__fabric;
    if(!f || !f.on){ if(t++ < 80){ setTimeout(hook, 150); } return; }
    if(f.__sbaTextTop){ return; } f.__sbaTextTop = true;
    function restack(){
      try{
        f.getObjects().forEach(function(o){ if(o && o.__t === 'text'){ f.bringToFront(o); } });
        f.requestRenderAll();
      }catch(e){}
    }
    f.on('object:added', function(e){ var o = e && e.target; if(o && o.__t === 'logo'){ restack(); } });
    restack();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', hook); } else { hook(); }
})();

/* 6) Checkout reassurance. Shopify's cart + checkout show the generic product thumbnail, so we rewrite the human-readable 'Your design' line-item property into a clear confirmation built from what the customer actually customised (logo + any text fields, incl. the arm sleeve's bicep/wrist zones). Wraps fetch so it applies to every personalizer's /cart/add.js call without editing each section. Only this descriptive text changes — the 'Design preview' link and every _-prefixed production field are left untouched. Renders as: "✅ Your custom design has been saved: <detail>". */
(function(){
  if(!window.fetch || window.fetch.__sbaDesignMsg){ return; }
  var orig = window.fetch;
  function rewrite(fd){
    try{
      if(!fd || typeof fd.forEach !== 'function' || !fd.set || !fd.delete){ return; }
      var hasLogo = false, texts = [];
      fd.forEach(function(value, key){
        if(key.indexOf('properties[_Team Logo') === 0){
          var real = (value && typeof value === 'object') ? ((value.size > 0) || ((value.name || '') !== '')) : ((''+value).length > 0);
          if(real){ hasLogo = true; }
        } else if(key === 'properties[_Text]' || key === 'properties[_Bicep text]' || key === 'properties[_Wrist text]'){
          var t = (''+value).trim();
          if(t){ texts.push(t); }
        }
      });
      var parts = [];
      if(hasLogo){ parts.push('Logo uploaded'); }
      if(texts.length === 1){ parts.push('Text: “' + texts[0] + '”'); }
      else if(texts.length > 1){ parts.push('Text: ' + texts.map(function(t){ return '“' + t + '”'; }).join(', ')); }
      var detail = parts.join(' + ');
      fd.delete('properties[Your design]');
      if(detail){ fd.set('properties[✅ Your custom design has been saved]', detail); }
    }catch(e){}
  }
  window.fetch = function(input, init){
    try{
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if(url.indexOf('/cart/add') !== -1 && init && init.body && typeof init.body.forEach === 'function'){
        rewrite(init.body);
      }
    }catch(e){}
    return orig.apply(this, arguments);
  };
  window.fetch.__sbaDesignMsg = true;
})();

/* ===== Cart drawer on personalizer add-to-cart =====
   For the SBA custom-product pages: instead of redirecting to /cart, open the theme's
   slide-out cart drawer with the item in it, so the customer keeps their design on screen
   and can add another unit. Only affects personalizer adds (body has properties[_Style]);
   all other add-to-cart flows are untouched. Falls back to normal /cart redirect if the
   cart drawer isn't present or anything goes wrong. */
(function(){
  if(window.__sbaCartDrawer) return; window.__sbaCartDrawer = true;
  if(!window.fetch) return;
  var orig = window.fetch;
  function isPersonalizerAdd(body){
    if(!body || typeof body.forEach !== 'function') return false;
    var yes = false;
    try{ body.forEach(function(v,k){ if(k === 'properties[_Style]') yes = true; }); }catch(e){}
    return yes;
  }
  function bodyHas(body, key){
    var has = false;
    try{ body.forEach(function(v,k){ if(k === key) has = true; }); }catch(e){}
    return has;
  }
  function resetBtns(){
    try{
      var bs = document.querySelectorAll('.sba__cart');
      for(var i=0;i<bs.length;i++){ bs[i].disabled = false; bs[i].innerHTML = '<span class="sba__cartlabel">Add to Cart</span>'; }
    }catch(e){}
  }
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    if(url.indexOf('/cart/add') === -1 || !init || !isPersonalizerAdd(init.body)){
      return orig.apply(this, arguments);
    }
    var cd = document.querySelector('cart-drawer');
    if(!cd || typeof cd.renderContents !== 'function'){
      return orig.apply(this, arguments); /* no drawer -> keep normal behavior */
    }
    try{
      if(!bodyHas(init.body, 'sections')){
        init.body.append('sections', 'cart-drawer,cart-icon-bubble');
        init.body.append('sections_url', window.location.pathname);
      }
    }catch(e){}
    return orig.apply(this, arguments).then(function(resp){
      if(!resp || !resp.ok) return resp; /* error -> let the page show its message */
      var clone;
      try{ clone = resp.clone(); }catch(e){ return resp; }
      return clone.json().then(function(data){
        var ok = false;
        try{
          if(data && data.sections){ cd.renderContents(data); resetBtns(); ok = true; }
        }catch(e){ ok = false; }
        if(ok){
          /* Swallow the rest of the caller's chain so it does NOT redirect to /cart. */
          return { ok:true, status:resp.status, json:function(){ return new Promise(function(){}); }, text:function(){ return new Promise(function(){}); } };
        }
        return resp; /* fallback: let the page redirect with the real response */
      }).catch(function(){ return resp; });
    });
  };
})();
